import $ from 'jquery'

import colors from '../../../../lib/colors'

import { button, input } from '../../../../component/component'

export default function(o,field,values,name,done){

  var v = []

  var generateButton = function(value){
    var b =
      button(value,'fi-x')
      .css({
        verticalAlign: 'top',
        margin: '1px',
      })
      .click(function(){
        $(this).remove()
        remove(value)
      })
    return b
  }

  var init = function(){
    requestAnimationFrame(function(){
      inputDiv.focus()
      _.each(values,function(value){
        v.push(value)
        valueDiv.append(
          generateButton(value)
        )
      })
    })
  }

  var update = function(){

    resultDiv.empty()

    var value = inputDiv.val()

    if(!value){
      return
    }

    var filteredOptions =
      _.filter(field.options,function(option){
        return _.includes(option.toLowerCase(), value.toLowerCase())
      })

    _.each(filteredOptions,function(option){
      resultDiv.append(
        button(option,'fi-plus')
        .css({
          display: 'block',
          marginBottom: '1px',
        })
        .click(function(){
          select(option)
        })
      )
    })

  }

  var cancel = function(){
    div.remove()
  }

  var save = function(){
    div.remove()
    done(v.join(', '))
  }

  var select = function(value){

    resultDiv.empty()
    inputDiv.val('')
    inputDiv.focus()

    valueDiv.append(
      generateButton(value)
    )

    v.push(value)
    v = _.uniq(v)
  }

  var remove = function(value){
    v = _.filter(v,function(option){
      return option != value
    })
    console.log(v)
  }

  var add = function(){

    var model = field.optionsModel

    model.insertForm(o, function(item){
      var lang = o.store('lang')
      select(item[lang])
    })

  }

  var label = name+'/'+field.id
  label = label.toUpperCase()
  var labelDiv = 
    button(label,null,true)
    .css({
      position: 'absolute',
      top: 0,
      left: 0,
    })
    .click(cancel)

  var cancelDiv = 
    button(null,'fi-x')
    .addClass('mousetrapEsc')
    .css({
      position: 'absolute',
      top: 0,
      right: '34px',
    })
    .click(cancel)

  var saveDiv = 
    button(null,'fi-check')
    .addClass('mousetrapShiftEnter')
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
    })
    .click(save)

  var addDiv = 
    button(null,'fi-plus')
    .css({
      position: 'absolute',
      top: 0,
      right: '68px',
    })
    .click(add)

  var headerDiv =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      height: '34px',
      color: colors.white,
      overflow: 'hidden',
      borderBottom: '1px solid '+colors.grey.s_800,
    })
    .append([
      labelDiv,
      cancelDiv,
      saveDiv,
      addDiv,
    ])

  var valueDiv = 
    $('<div>')
    .css({
      position: 'absolute',
      top: '34px',
      height: '100px',
      right: 0,
      left: 0,
      overflow: 'scroll',
      margin: '1px'
    })

  var inputDiv =
    input()
    .css({
      position: 'absolute',
      top: '134px',
      right: 0,
      left: 0,
      height: '34px',
      borderTop: `1px solid ${colors.grey.s_800}`,
      borderBottom: `1px solid ${colors.grey.s_800}`,
    })
    .on('keyup',update)

  var resultDiv = 
    $('<div>')
    .css({
      position: 'absolute',
      top: '168px',
      bottom: 0,
      right: 0,
      left: 0,
      overflow: 'scroll',
    })
    .append(
      button('start typing',null,true,colors.grey.s_500)
    )

  var div =
    $('<div>')
    .css({
      position: 'absolute',
      top: 0,
      right: 0,
      left: 0,
      bottom: 0,  
      background: colors.black,
    })
    .append([
      headerDiv,
      valueDiv,
      inputDiv,
      resultDiv,
    ])

  if(field.add){
    div.append(addDiv)
  }

  o.edit.append(div)

  init()

}



// WEBPACK FOOTER //
// ./src/client/view/admin/edit/options/options.js